import * as RadixToggleGroup from '@radix-ui/react-toggle-group';

import { cx } from '@/shared/lib/cx';

import styles from './Segmented.module.scss';

export interface SegmentedOption {
  value: string;
  label: string;
}

export interface SegmentedProps {
  options: readonly SegmentedOption[];
  value: string;
  onValueChange: (value: string) => void;
  'aria-label'?: string;
  className?: string;
  disabled?: boolean;
}

/**
 * Кнопки в ряд для двух-четырёх коротких вариантов: «Онлайн / Офлайн»,
 * «Во всю ширину / Половина». Выбранное видно без открытия списка.
 *
 * Снять выбор повторным нажатием нельзя: у такого выбора всегда есть
 * значение, а пустое состояние читалось бы как сбой.
 */
export function Segmented({ options, value, onValueChange, className, ...rest }: SegmentedProps) {
  return (
    <RadixToggleGroup.Root
      type="single"
      value={value}
      onValueChange={(next) => {
        if (next !== '') {
          onValueChange(next);
        }
      }}
      className={cx(styles['segmented'], className)}
      {...rest}
    >
      {options.map((option) => (
        <RadixToggleGroup.Item
          key={option.value}
          value={option.value}
          className={styles['segment']}
        >
          {option.label}
        </RadixToggleGroup.Item>
      ))}
    </RadixToggleGroup.Root>
  );
}
